import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Star, Timer } from "lucide-react";
import { toast } from "sonner";
import { api, fmtDate, fmtTL } from "../lib/api";
import { useShop } from "../context/ShopContext";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";

export default function Campaigns() {
    const [items, setItems] = useState(null);
    const { refreshCart } = useShop();

    useEffect(() => {
        api.get("/featured").then((r) => setItems(r.data)).catch((e) => {
            if (e.response?.status === 403) setItems([]);
        });
    }, []);

    const addToCart = async (f) => {
        try {
            await api.post("/cart/items", { offer_id: f.offer_id, qty: 1 });
            await refreshCart();
            toast.success("Sepete eklendi");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Eklenemedi");
        }
    };

    return (
        <div className="space-y-6" data-testid="campaigns-page">
            <div>
                <h1 className="font-display text-3xl font-bold tracking-tight">Kampanyalı Ürünler</h1>
                <p className="mt-1 text-sm text-muted-foreground">Admin onaylı, aktif kampanyalı ürünler — yalnızca üye mağazalara özeldir.</p>
            </div>
            {!items ? (
                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">{[...Array(3)].map((_, i) => <div key={i} className="h-72 animate-pulse rounded-2xl bg-muted" />)}</div>
            ) : (
                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="campaigns-grid">
                    {items.map((f) => (
                        <div key={f.featured_id} className="group overflow-hidden rounded-2xl border bg-card shadow-sm transition-shadow hover:shadow-md" data-testid={`campaign-card-${f.featured_id}`}>
                            <Link to={`/panel/urun/${f.product.product_id}`} className="relative block">
                                <img src={f.product.image} alt={f.product.name} className="aspect-[4/3] w-full object-cover" loading="lazy" />
                                <Badge className="absolute left-2 top-2 border-0 bg-red-600 text-[10px] font-bold text-white" data-testid={`campaign-discount-${f.featured_id}`}>%{f.discount_percent} İndirim</Badge>
                            </Link>
                            <div className="p-4">
                                <p className="font-display text-sm font-bold leading-snug">{f.product.name}</p>
                                <p className="mt-0.5 text-xs text-muted-foreground">{f.supplier?.name} • {f.supplier?.city} <Star className="inline h-3 w-3 fill-saffron-400 text-saffron-400" /> {f.supplier?.trust_score}</p>
                                <div className="mt-2 flex items-baseline gap-2">
                                    <span className="font-display text-lg font-extrabold text-terra-600">{fmtTL(f.campaign_price)}</span>
                                    <span className="text-xs text-muted-foreground line-through">{fmtTL(f.price)}</span>
                                    <span className="text-xs text-muted-foreground">/ {f.product.unit} (KDV dahil)</span>
                                </div>
                                <p className="mt-1 flex items-center gap-1 text-[10px] text-amber-700"><Timer className="h-3 w-3" /> {f.campaign_name} — son: {fmtDate(f.campaign_ends_at)}</p>
                                <Button size="sm" className="mt-3 w-full bg-terra-600 text-white hover:bg-terra-700" onClick={() => addToCart(f)} data-testid={`campaign-add-${f.featured_id}`}>
                                    <ShoppingCart className="mr-1.5 h-3.5 w-3.5" /> Sepete Ekle
                                </Button>
                            </div>
                        </div>
                    ))}
                    {!items.length && (
                        <p className="col-span-full rounded-2xl border border-dashed p-16 text-center text-sm text-muted-foreground" data-testid="campaigns-empty">Şu anda kampanyalı ürün yok.</p>
                    )}
                </div>
            )}
        </div>
    );
}
